<template>
    <div>
        <form @submit.prevent="submitFilters">
            <div class="row">

                <div class="col-12 col-md-6 mb-2">
                    <label class="akkurate-dark small" for="date">From Date</label>
                    <b-form-group label-for="start_date" class="akkurate-dark">
                        <b-form-input id="start_date" class="mt-1 field-container fields" type="date"
                            v-model="form.start_date">
                        </b-form-input>
                    </b-form-group>
                </div>

                <div class="col-12 col-md-6">
                    <label class="akkurate-dark small" for="date">To Date</label>
                    <b-form-group label-for="end_date" class="akkurate-dark">
                        <b-form-input id="end_date" class="mt-1 field-container fields" type="date"
                            v-model="form.end_date">
                        </b-form-input>
                    </b-form-group>
                </div>


                <div class="col-12 col-md-6 mb-2">
                    <label class="akkurate-dark small" for="entry_type">Entry Type</label>
                    <multiselect class="mt-1 field-container" v-model="form.entry_type" :options="entry_mode_options"
                        placeholder="Select one" selectLabel="" deselectLabel="">
                    </multiselect>
                </div>


                <div class="col-12 col-md-6 mb-2">
                    <label class="akkurate-dark small" for="transaction_type">User(s)</label>
                    <multiselect class="mt-2 field-container" v-model="form.users" :options="users_options"
                        placeholder="Select User" selectLabel="" :custom-label="fullName" :close-on-select="false"
                        :clear-on-select="false" :multiple="true" deselectLabel="" :limit-text="limitText" :limit="1"
                        track-by="id">
                    </multiselect>
                </div>

            </div>
        </form>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
    components: {
        Multiselect
    },
    props: ['form', 'users_options'],
    data() {
        return {
            more_details: false,
            entry_mode_options: ['RECEIPT', 'PAYMENT'],
        }
    },
    methods: {
        submitFilters() {
            this.$emit("submitFilters");
        },

        show_more() {
            this.more_details = !this.more_details
        },
        fullName({ first_name, surname, code }) {
            let name = "";
            if (first_name) {
                name = name + first_name;
            }

            if (surname) {
                name = name + " " + surname;
            }

            return `${name}`;
        },
        limitText(count) {
            return `and ${count} other user(s)`;
        },
    }
}

</script>